export enum EServiceMapContent {
  DETAIL = "detail",
  INFORMATION = "information",
  SERVICE_CONFIG = "serviceConfig",
}
